import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type BuyButtonProps = {
  label: string;
  size?: "md" | "lg";
  id?: string;
  href?: string;
  className?: string;
};
// Pasa al checkout los parámetros de la visita (UTMs, fbclid...) para que la venta quede atribuida al anuncio.
// El evento InitiateCheckout lo dispara el checkout de Impultienda (no se duplica acá).
function withVisitParams(url: string) {
  if (typeof window === "undefined" || !window.location.search) return url;
  const target = new URL(url);
  new URLSearchParams(window.location.search).forEach((value, key) => {
    if (!target.searchParams.has(key)) target.searchParams.set(key, value);
  });
  return target.toString();
}
export function BuyButton({
  label,
  size = "lg",
  id,
  href = CHECKOUT_URL,
  className = ""
}: BuyButtonProps) {
  const isCheckout = href === CHECKOUT_URL;
  const sizing = size === "lg" ? "w-full min-h-[62px] gap-2.5 rounded-2xl px-5 py-3.5 text-[15px] sm:text-lg" : "min-h-[48px] gap-1.5 rounded-xl px-4 py-2 text-[13px]";
  return <a id={id} href={href} onClick={isCheckout ? e => {
    e.currentTarget.href = withVisitParams(CHECKOUT_URL);
  } : undefined} className={`btn-gold group relative inline-flex items-center justify-center overflow-hidden text-center font-extrabold uppercase leading-tight tracking-tight text-navy transition-[transform,filter] duration-150 ease-out hover:brightness-105 active:scale-[0.97] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 ${sizing} ${className}`} data-id="element-32" data-mp="1c9k8cadpombv">
      <span className="btn-shine" aria-hidden="true" data-id="element-33" data-mp="fjuh7f4jimnd" />
      <span className="relative" data-id="element-34" data-mp="fl5ldg1wdwf0">{label}</span>
      <ArrowRightIcon className={`relative shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-0.5 ${size === "lg" ? "h-5 w-5" : "h-4 w-4"}`} aria-hidden="true" data-id="element-35" data-mp="jkwh7y6a72qe" />
    </a>;
}